import { AppLayoutWithHeader } from "@/components/layout/AppLayoutWithHeader";
import { SubscriptionManagerV3 } from "@/components/subscription/SubscriptionManagerV3";

export default function SubscriptionNew() {
  return (
    <AppLayoutWithHeader
      title="Mon abonnement"
      subtitle="Gérez votre abonnement, achetez des crédits et consultez vos factures"
    >
      <SubscriptionManagerV3 />
    </AppLayoutWithHeader>
  );
}